'use client';

import { LocalUserChoices } from '@livekit/components-react';
import { createContext, useContext, useState, ReactNode } from 'react';

type PreJoinContextType = {
  preJoinChoices: LocalUserChoices | null;
  setPreJoinChoices: (choices: LocalUserChoices) => void;
  hasCompletedPreJoin: boolean;
};

const defaultPreJoinChoices = {
  username: '',
  videoEnabled: false, // Always start disabled - user must explicitly enable
  audioEnabled: false, // Always start disabled - user must explicitly enable
  videoDeviceId: 'default',
  audioDeviceId: 'default',
};

const PreJoinContext = createContext<PreJoinContextType>({
  preJoinChoices: null,
  setPreJoinChoices: () => {},
  hasCompletedPreJoin: false,
});

export function PreJoinProvider({ children }: { children: ReactNode }) {
  const [preJoinChoices, setPreJoinChoicesState] = useState<LocalUserChoices | null>(null);
  const [hasCompletedPreJoin, setHasCompletedPreJoin] = useState(false);

  const setPreJoinChoices = (choices: LocalUserChoices) => {
    setPreJoinChoicesState(choices);
    setHasCompletedPreJoin(true);
  };

  return (
    <PreJoinContext.Provider
      value={{
        preJoinChoices,
        setPreJoinChoices,
        hasCompletedPreJoin,
      }}
    >
      {children}
    </PreJoinContext.Provider>
  );
}

export function usePreJoin() {
  return useContext(PreJoinContext);
}

export { defaultPreJoinChoices };
